<template>
  <responsive-modal v-model="visible" title="Integrar Spedy">
    <div class="tool-modal-spedy">
      <a href="https://spedy.com.br/" target="_blank" class="integration-link">
        Conheça o Spedy
        <i class="ph ph-arrow-square-out" />
      </a>
      <action-dispatcher
        action="integration/getCoproducerProducts"
        :parameters="{ limit: 500 }"
      >
        <snow-select
          :disabled="form.id != null"
          id="product-select"
          label="Produto"
          required
          v-model="form.product_id"
          :errors="errors.product_id"
          :options="
            coproducerProducts.map(product => ({
              id: product.product_id,
              name: product.product_name
            }))
          "
        />
      </action-dispatcher>
      <snow-input
        label="Descrição da integração (Opcional)"
        required
        id="description"
        v-model="form.description"
        :errors="errors.description"
      />
      <snow-input
        id="token"
        required
        label="Token"
        v-model="form.token"
        :errors="errors.token"
      />
      <div class="snow-submit-buttons mt-3">
        <snow-button
          size="lg"
          class="order-lg-1"
          :disabled="!isValid"
          @click="submit"
          text="Salvar"
        />
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["product_id", "token", "status", "description"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["coproducerProducts"]),
    isValid() {
      return this.form.product_id && this.form.token && this.validDocument;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(this.onSuccess)
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-spedy {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
